<template>
    <q-card class="full-width full-height ">
        <q-card-media @click.native="clickCard()" class="cursor-pointer">
            <img :src="library.image_original" v-if="library.image_original">
            <img :src="getPlaceholder" v-if="!library.image_original">
        </q-card-media>

        <q-card-main>
            <p class="q-subheading text-weight-medium text-primary title-library">{{ library.title }}</p>
            <p class="text-faded q-mt-md">{{ $t('category') }}: {{ getCategory(library.category) }}</p>

            <div class="tags-library q-mt-md">
                <span class="text-faded" v-if="library.tags.length > 0">{{ $t('tags') }}:
                    <span v-for="(tag, index) in library.tags" :key="index">
                        {{ getTag(tag) }}<span v-if="(library.tags.length - 1) > index">, </span>
                    </span>
                </span>
            </div>
        </q-card-main>

        <q-card-separator />

        <q-card-actions class="justify-center action-library" style="height: 90px;">
            <q-btn flat :label="library.size" icon="far fa-hdd" />
            <q-btn flat :label="library.hits" icon="fas fa-download" />
            <q-btn flat :label="library.extension" :icon="$extensionIcon(library.extension)" />
        </q-card-actions>

        <q-card-separator />

        <q-card-actions class="justify-center">
            <q-btn class="full-width q-my-sm" :label="$t('open')" icon="far fa-eye" color="secondary" @click="clickCard()" />
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['library'],

    data() {
        return {
            card_image: this.library.file_url_complete
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            all_categories: 'site_lists/library_file_categories',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getPlaceholder() {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
                this.card_image = client.group_library_file_placeholder
                return client.group_library_file_placeholder
            }
			else return ''
        },
    },

    methods: {
        clickCard() {
            this.$emit('cardClicked', this.library.id)
        },

        getCategory(id) {
            let obj = this.all_categories.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        downloadFile() {
            let file = this.library.file_url_complete.substring(this.library.file_url_complete.lastIndexOf('/')+1)
            let extension = file.substring(file.lastIndexOf('.'))
            let fileName = `${this.library.title}${extension}`

            if (this.$q.platform.is.cordova) {
                cordova.InAppBrowser.open(this.library.file_url_complete, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                this.hitDownload()
            }
            else {
                window.open(this.library.file_url_download, '_blank')
                this.hitDownload()
            }
        },

        hitDownload() {
            this.$axios.get(`/etraining_library_files/files/${this.library.id}/request_file_download/`, this.getHeader)
            .then(response => {
                this.$emit('changeHits', this.library.id)
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.title-library
    min-height 70px

.tags-library
    min-height 30px

</style>
